import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

interface BRANDPARAMS {
  brandCode?: string // 品牌编码
  brandNameCn?: string // 品牌中文名
  brandNameEn?: string // 品牌英文名
  manageType?: string // 经营方式 (1_品牌方 2_集货商)
  mpmState?: string // 审核状态(1-审核中,2-驳回,3-审核通过)
  pageNo: string
  pageSize: string
  schemeId?: string // 搜索方案id
  tabType: string
}
interface BRANDADDPARAMS {
  brandLogoUrl?: string // 品牌logourl
  brandMpmId?: string // 品牌mpmid
  brandNameCn: string // 品牌中文名
  brandNameEn: string // 品牌英文名
  desc?: string // 描述
  erpCode: string // SUPPLIER_ERPCODE
  erpId?: string //
  manageType: string // 经营方式
  supplierId: string // 供应商id SUPPLIERID
  supplierName: string // 供应商名称HOME_DATA-> enterpriseName
  supplierUserId: string // 供应商用户id USERID
}

// 获取品牌信息
export const GET_SUPPLIER_BRAND_PAGE = (params: BRANDPARAMS) =>
  GET(`${HTTP}/supplierBrand/getSupplierBrandPage`, params)

// 获取品牌详情信息
export const GET_SUPPLIER_BRAND_DETAIL = (params: { brandId: string }) =>
  GET(`${HTTP}/supplierBrand/getSupplierBrandDetail`, params)

// 新增品牌信息
export const SUPPLIER_BRAND_ADD = (params: BRANDADDPARAMS) =>
  POST(`${HTTP}/supplierBrand/supplierBrandAdd`, params, 'application/json')
import request from '../tools/request'
import { HTTP } from './http'
const { GET, POST } = request

interface BRANDPARAMS {
  brandCode?: string // 品牌编码
  brandNameCn?: string // 品牌中文名
  brandNameEn?: string // 品牌英文名
  manageType?: string // 经营方式 (1_品牌方 2_集货商)
  mpmState?: string // 审核状态(1-审核中,2-驳回,3-审核通过)
  pageNo: string
  pageSize: string
  schemeId?: string // 搜索方案id
  tabType: string
}
interface BRANDADDPARAMS {
  brandLogoUrl?: string // 品牌logourl
  brandMpmId?: string // 品牌mpmid
  brandNameCn: string // 品牌中文名
  brandNameEn: string // 品牌英文名
  desc?: string // 描述
  erpCode: string // SUPPLIER_ERPCODE
  erpId?: string //
  manageType: string // 经营方式
  supplierId: string // 供应商id SUPPLIERID
  supplierName: string // 供应商名称HOME_DATA-> enterpriseName
  supplierUserId: string // 供应商用户id USERID
}

// 获取品牌信息
export const GET_SUPPLIER_BRAND_PAGE = (params: BRANDPARAMS) =>
  GET(`${HTTP}/supplierBrand/getSupplierBrandPage`, params)

// 获取品牌详情信息
export const GET_SUPPLIER_BRAND_DETAIL = (params: { brandId: string }) =>
  GET(`${HTTP}/supplierBrand/getSupplierBrandDetail`, params)

// 新增品牌信息
export const SUPPLIER_BRAND_ADD = (params: BRANDADDPARAMS) =>
  POST(`${HTTP}/supplierBrand/supplierBrandAdd`, params, 'application/json')
